/**
 * Central route path definitions.
 * Import from 'config' or 'Routes' (re-exported from Routes.js).
 */
export const PageURLs = {
  // Public browsing
  Home: '/',
  Categories: '/categories',
  CategoryDetail: '/categories/:slug',
  Brands: '/brands',
  BrandDetail: '/brands/:slug',
  ProductListing: '/products',
  ProductDetails: '/products/:productId',
  SearchResults: '/products/search',
  Offers: '/offers',
  CmsPage: '/pages/:slug',

  // Cart & checkout
  Cart: '/cart',
  Checkout: '/checkout',
  OrderSuccess: '/order-success/:orderId',

  // Auth-gated
  OrderHistory: '/orders',
  OrderDetail: '/orders/:orderId',
  Order: '/orders',          // legacy alias kept for /orders/:id navigation
  PayNow: '/pay-now/:orderId',
  Favourites: '/favourites',
  Profile: '/profile',
  ProfileAddresses: '/profile/addresses',
  ProfileSecurity: '/profile/security',
  Support: '/support',
  SupportNew: '/support/new',
  SupportTicket: '/support/:ticketId',
  Settings: '/settings',

  // Auth pages
  Login: '/login',
  Register: '/register',
  ForgotPassword: '/forgot-password',

  // Misc
  NotFound: '/404',
}
